import React, { useContext, useEffect, useState } from 'react';
import './MobileForm.scss';
import Input from '../../../../Common/Global/Input';
import Button from '../../../../Common/Global/Button';
import LoginServiceObject from "../../../../Common/services/Login";
import { STOREDATA } from '../../../../Common/context/data-mapping/action/action.type';
import DataMapping from '../../../../Common/context/data-mapping/data-mapping';
import { useLocation, useNavigate } from 'react-router';
import OkButtonPopUp from '../../../../Common/Global/OkButtonPopUp';
import FailurePopUp from '../../../../Common/Global/FailurePopUp';
import configUrlObj from '../../../../Common/Configuration';
import commonFunctionObject from '../../../../Common/common-function';
import { useCookies } from 'react-cookie';


const MobileForm = () => {
    const [data, dispatchData] = useContext(DataMapping)
    const [mobileInput, setMobileInput] = useState("");
    const [userId, setUserId] = useState("");
    const [mobInputError, setMobInputError] = useState();
    const mobileRegex = /^[6789][0-9]{9}$/;
    const navigate = useNavigate();
    const location = useLocation();
    const [okButtonPopUpFlag, setOkButtonPopUpFlag] = useState(false);
    const [okButtonPopUpContent, setOkButtonPopUpContent] = useState("");
    const [okButtonPopUpContentother, setOkButtonPopUpContentother] = useState("");
    
    const [failurePopUpModal, setFailurePopUpModal] = useState(false);
    const [failurePopUpContent, setFailurePopUpContent] = useState({
        "apiName": "",
        "message": "",
        "errorCode": ""
    });

    const getURLParams = (url) => {
        var queryParams = {};
        try {
            url = url ? url : window.location.search;
            url.split("?")[1].split("&").forEach(function (pair) {
                var key = pair.split("=")[0];
                var val = pair.split("=")[1];
                queryParams[key] = val;
            });
        }
        catch (err) { return "" }
        return queryParams;
    }
    useEffect(() => {
        const parameter = getURLParams(location.search);

        if (parameter.src) {
            if (parameter.src.toLowerCase() === "website") {
                let urlParams = {
                    src: parameter.src,
                    isExisting: parameter.isExistingCustomer
                }
                dispatchData({
                    type: STOREDATA,
                    name: "urlParameter",
                    payload: urlParams
                })
                dispatchData({
                    type: STOREDATA,
                    name: "mobileotpCalled",
                    payload: false
                })
                if (parameter.isExistingCustomer.toLowerCase() === "false") {
                    navigate("/personal-details")
                    console.log("personal details")
                }

            }else if (parameter.src.toLowerCase() === "pgs") {
                let urlParams = {
                    src: parameter.src,
                    isExisting: parameter.isExistingCustomer
                }
                dispatchData({
                    type: STOREDATA,
                    name: "urlParameter",
                    payload: urlParams
                })
                dispatchData({
                    type: STOREDATA,
                    name: "mobileotpCalled",
                    payload: false
                })
                    navigate("/personal-details")
                    console.log("personal details")

            }
             else {
                //  moneyfy
                let urlParams = {
                    src: parameter.src,
                    data: parameter.data
                }
                dispatchData({
                    type: STOREDATA,
                    name: "urlParameter",
                    payload: urlParams
                })
                dispatchData({
                    type: STOREDATA,
                    name: "mobileotpCalled",
                    payload: true
                })
               

                navigate("/personal-details", { state: { search: "?src=" + parameter.src + "&data=" + parameter.data } })
            }

        } else {
            //navigate to  personal-details
        }
        commonFunctionObject.scrollToTop()
    }, [])


    const handleMobileChange = (mobNumber) => {
        setMobileInput(mobNumber);
        console.log(mobileInput)
        if (mobNumber !== "") {

            if (mobNumber.match(mobileRegex)) {
                if (mobNumber.length === 10) {
                    setMobInputError("");
                } else {
                    setMobInputError("Kindly Provide A Valid Mobile No.")
                }
            } else {
                setMobInputError("Please Provide Your Registered Mobile No");
            }

        } else {
            setMobInputError("Please Provide Your Registered Mobile No");
        }

    }

    const handleSubmit = (e) => {

        e.preventDefault();
        if (mobileInput !== "" && mobInputError === "") {
            let requestObj = {
                "body": {
                    "mobileNo": mobileInput,
                },
                "header": {
                    "authToken": configUrlObj.authToken[configUrlObj.environment],
                }
            };
            dispatchData({
                name: "loaderFlag",
                payload: true,
                type: STOREDATA
            });


            commonFunctionObject._setCookie('Authorization', configUrlObj.authToken[configUrlObj.environment]);

            LoginServiceObject.getUserIdService(requestObj, mobileInput).then((getUserIdResponse) => {
                console.log("getUserIdResponse", getUserIdResponse)
                setUserId(getUserIdResponse.body.PRIMARY_GCID);
                let reqObj = {
                    "header": {
                        "grantType": "otp",
                        "serviceType": "mobile",
                        "authToken": configUrlObj.authToken[configUrlObj.environment],
                        "journeyType": "postLogin"
                    },
                    "body": {
                        "mobileNo": mobileInput
                    }
                }
            commonFunctionObject._setCookie('Authorization', configUrlObj.authToken[configUrlObj.environment]);
                LoginServiceObject.generateMobOtpService(reqObj).then((response) => {
                    console.log("generateMobResponse", response)
                    if (response) {
                        let validateOtpObj = {
                            status: "login",
                            mobileNo: mobileInput,
                            refId: response.body.otpRefNo,
                            gcid: getUserIdResponse.body.PRIMARY_GCID
                        }
                        dispatchData({
                            type: STOREDATA,
                            name: "generateMobResponse",
                            payload: validateOtpObj
                        })
                        navigate("/verify-otp");
                        dispatchData({
                            name: "loaderFlag",
                            payload: false,
                            type: STOREDATA
                        });

                    }
                }).catch((error) => {
                    setFailurePopUpContent({
                        apiName: "",
                        message: "We are currently facing error in OTP services. Please try again later",
                        errorCode: error
                    })
                    setFailurePopUpModal(true)
                    dispatchData({
                        name: "loaderFlag",
                        payload: false,
                        type: STOREDATA
                    });
                })

            }).catch((error) => {
                if(error == `Hey! It seems this number is not registered with us. To continue as "New Customer" click below.`){
                    setOkButtonPopUpContent("Hey! It seems this number is not registered with us.")
                    setOkButtonPopUpContentother('To continue as "New Customer" click below.')

                }
                setOkButtonPopUpFlag(true)
                dispatchData({
                    name: "loaderFlag",
                    payload: false,
                    type: STOREDATA
                });
                let urlParams = {
                    src: "website",
                    isExisting: "false",
                }
                dispatchData({
                    type: STOREDATA,
                    name: "urlParameter",
                    payload: urlParams
                })
            })

        } else {
            setMobInputError("Please Provide Your Registered Mobile No")
            console.log("Please Enter Mob Number")
        }

    }
    const onClosePopUp = () => {
        setFailurePopUpModal(false);
    }

    return (
        <>
            <div className="mobile-form-login-border">
                <div className='mobile-form-container'>
                    <form className="mobile-form" onSubmit={(e) => {
                        handleSubmit(e)
                    }}>
                        <div className="mobile-form-title">
                            <h2>Enter Registered Mobile Number</h2>
                        </div>
                        {/* <div></div> */}
                        <div className='mobile-input-container'>
                            <Input name="mobileNumber" className="mobile-num-input" tooltipMessage="Mobile Number" maxLength="10" value={mobileInput}
                                onChange={(event) => {
                                    handleMobileChange(event.target.value);
                                }}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                error={mobInputError}
                            />
                            {/* <label class="tooltip-text">Mobile Number</label> */}
                        </div>
                        <div className='btn-container'>
                            <Button className="get-otp-btn" type={"submit"}>
                                Get OTP
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
            {okButtonPopUpFlag ? <OkButtonPopUp
                onClick={() => {
                    navigate("/personal-details")
                }}
                visible={okButtonPopUpFlag}
                setModalStat={setOkButtonPopUpFlag}
                Content={okButtonPopUpContent} Contentother={okButtonPopUpContentother} /> : null}
            {failurePopUpModal ? <FailurePopUp
                onClick={() => onClosePopUp()}
                visible={failurePopUpModal}
                setFailureModalStat={setFailurePopUpModal}
                failurePopUpContent={failurePopUpContent}
            /> : null}
        </>
    )
}

export default MobileForm